import script from "./IndexMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexMobile.vue?vue&type=script&setup=true&lang=ts"

import "../../style/IndexMobile.css?vue&type=style&index=0&id=65b59ced&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b59ced"]])

export default __exports__